<template>
    <v-layout row justify-center>
        <v-dialog v-model="exibirModal" persistent :max-width="Modal.Confirmacao.larguraMaxima">
            <v-card :max-width="Modal.Confirmacao.larguraMaxima" :min-width="Modal.Confirmacao.larguraMinima">
                <v-card-title class="modal-title primary white--text py-0" primary-title>
                    <span>Iniciar Desempate</span>
                    <v-spacer></v-spacer>
                    <v-btn flat depressed icon small @click="$emit('fecharModal')">
                        <v-icon color="white">close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-text class="text-xs-center grey--text text--darken-2">
                    <h4 class="mb-3 ">⚠️ Atenção !!! </h4>
                    <p class="body-2">
                        Enviar lance para <strong>disputa fechada?</strong><br>
                        Os licitantes terão 5 minutos para<br>
                        enviar novo valor.<br>
                    </p>
                </v-card-text>
                <v-card-actions class="px-3 py-2">
                    <v-btn color="botao-cancelar-color" outline flat @click="$emit('fecharModal')">Cancelar</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" depressed @click="$emit('desempatar')">Enviar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-layout>
</template>

<script>

import {Modal} from '@/core/constants'

export default {
    name: 'ModalDesempateEtapaFechada',
    data() {
        return {
            Modal
        }
    },
    props: ['exibirModal']
}
</script>

<style scoped lang="stylus">
.acoes
    padding 20px 0 !important

.botao-primario
    padding 0 25px
    border 1px solid var(--v-primary-base) !important
    background-color var(--v-primary-base) !important
    color #fff !important
    box-sizing border-box
    margin-left 15px !important

.wc
    color #EDAE00
</style>